import "./CaseOfficerEvaluationForm.scss"
import { CaseOfficerProvider } from "../../features/CaseOfficerReviewForm/CaseOfficerContex";
import CaseOfficerForm from "../../features/CaseOfficerReviewForm/CaseOfficerForm";
const CaseOfficerEvaluation = () => {
  return (
    <CaseOfficerProvider >
      <div className="page-container">
        <CaseOfficerForm />
      </div>
    </CaseOfficerProvider >
  );
};
export default CaseOfficerEvaluation;
